import React from "react";
import { AiFillEdit, AiFillDelete } from "react-icons/ai";
import { Button, Card, Col, Row } from "react-bootstrap";
import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import {
  deleteDestination,
  popular_destination,
} from "../../services/authServices";
import MainTitle from "../../components/mainTitile/mainTitle";
import TablePagination from "../../components/pagination/tablePagination";
import CustomButton from "../../components/button/button";
import "./popularDesintation.css";
import CustomLoader from "../../components/loader/loader";

const PopularDestinationComponent = () => {
  const [popularData, setPopularData] = useState([]);
  const [isLoading, setLoading] = useState(false);

  let navigate = useNavigate();
  //To take all the data from the backend
  const getPopularData = async () => {
    try {
      setLoading(true);
      const res = await popular_destination();
      setPopularData(res.data.Data.getData);
      setLoading(false);
    } catch (e) {
      console.error(e);
    }
  };

  useEffect(() => {
    getPopularData();
  }, []);

  const formpage = () => {
    let path = "/destinationForm";
    navigate(path);
  };

  const handleDelete = (userid, e) => {
    deleteDestination(userid);
  };

  return (
    <div>
      <CustomLoader isLoading={isLoading} />
      <Row>
        <Col sm={10} className="pt-3">
          <MainTitle
            heading={"Popular Destination Details"}
            textAlign={"center"}
          />
        </Col>

        <Col sm={2}>
          <CustomButton buttonText={"Add"} onClick={formpage} />
        </Col>
      </Row>
      <div className="grid_container">
        {popularData
          .sort((a, b) => a.order_id - b.order_id)
          ?.map((aItem) => (
            <Card className="p-3">
              <Row>
                <Col className="py-2">
                  <h6>{aItem.order_id}</h6>
                </Col>
              </Row>
              <Row>
                <img
                  src={aItem.image}
                  className="size image-fluid p-1"
                  alt="offers"
                />
                <Col>
                  <p className="title">{aItem.title}</p>
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <Link>
                    <Button
                      variant="outline-danger"
                      className="mt-1 container"
                      onClick={() => handleDelete(aItem._id)}
                    >
                      <AiFillDelete /> Delete
                    </Button>
                  </Link>
                </Col>
                <Col sm={6}>
                  <Link to={`/destinationForm/${aItem._id}`}>
                    <Button variant="light" className="mt-1 container">
                      <AiFillEdit /> Edit
                    </Button>
                  </Link>
                </Col>
              </Row>
            </Card>
          ))}
      </div>

      <TablePagination />
    </div>
  );
};

export default PopularDestinationComponent;
